import { Link } from "react-router-dom";
import { footerImages } from "../assets/images/footer/images";
import { socialNetworkData } from "../assets/images/icons/imagesSocialNetworks";
import logoMafirol from "../assets/images/logos/Redesign_Logótipo_(branco).svg";
import livroReclamacoes from "../assets/images/footer/Livro_de_Reclamações.svg";
import { useTranslation } from "react-i18next";
import { useLocalizedNavigation } from "../hooks/useLocalizedNavigation";

export const Footer = () => {
  const { t } = useTranslation("footer");
  const { localizePath } = useLocalizedNavigation();
  const isSnapshot =
    typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

  const footerLinks = [
    { key: "products", path: "/products" },
    { key: "aboutus", path: "/aboutus" },
    { key: "downloadArea", path: "/downloadarea" },
    { key: "recruitment", path: "/recruitment" },
    { key: "contacts", path: "/contacts" },
    { key: "complaints", path: "/complaint" },
  ].filter((item) => !(isSnapshot && item.path === "/recruitment"));

  return (
    <footer className="footer">
      <div className="footer__Mafirol">
        <div className="footer__logo-disclaimer">
          <Link to={localizePath("/")}>
            <img src={logoMafirol} alt="Mafirol" />
          </Link>
          <p>
            <span>{new Date().getFullYear()}</span>. {t("disclamer")}
            <Link to={localizePath("/privacyrules")}> {t("privacyrules")}</Link>
          </p>
        </div>

        <div className="footer__links">
          <ul>
            {footerLinks.map((item) => (
              <li key={item.path}>
                <Link to={localizePath(item.path)}>{t(item.key)}</Link>
              </li>
            ))}
          </ul>

          <div className="footer__links-bottom">
            <a
              href="https://www.livroreclamacoes.pt/Inicio/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={livroReclamacoes} alt="Livro de Reclamacoes" className="livro" />
            </a>

            <div className="social-icons">
              {socialNetworkData.map((src) => (
                <Link key={src.name} href="#" target="_blank" to={src.link}>
                  <img src={src.image} alt={src.name} />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="footer__UE">
        {footerImages.map((src, index) => (
          <img key={index} src={src} alt={`Certificacao ${index + 1}`} loading="lazy" />
        ))}
      </div>
    </footer>
  );
};
